import React from "react";
import "./home.scss";
import Header from "../Section/Header/navbar";
import Banner from "../Section/Banner/banner";
import About from "../Section/secondhero/SecondHero";

import Orlens from "../Section/Orleans/Orleans";

import AP from "../Section/AP/AP";
import Residential from "../Section/Produk/Produk";
import AR from "../Section/AR/AR";
import Ruko from "../Section/Ruko/Ruko";
import Fasilitas from "../Section/Fasilitas/fasilitas";
import Fasilitaslist from "../Section/Fasilitaslist/fasilitaslist";
import Lokasi from "../Section/Lokasi/lokasi";
import Footer from "../Section/Footer/Footer";
import Scrolltohashelement from "../Pages/ScrollToHashElement";

const home = () => {
  return (
    <div className="home">
      <Header />
      <Banner />
      <About />

      <Orlens />
      <AP />
      <Residential />
      <AR />
      <Ruko />
      <Fasilitas />
      <Fasilitaslist />
      <Lokasi />
      <Footer />
      <Scrolltohashelement />
    </div>
  );
};

export default home;
